// libraries
import { z } from 'zod';

export type UnitInputMode = 'sensorId' | 'apiInput' | 'externalSensorId';

export type UnitTypeInputDefinition = {
  UnitTypeInputId: number;
  Name: string;
};

export type RecordedDataType = {
  UnitTypeInput?: {
    UnitTypeInputId?: number;
    Name?: string;
  };
  DataTypes?: string[];
};

export type SelectedUnitType = {
  UnitTypeId: number;
  Name: string;
  UnitTypeInputs?: UnitTypeInputDefinition[];
  RecordedDataTypes?: RecordedDataType[];
};

export const unitTypeInputValueSchema = z.object({
  inputType: z.enum(['sensorId', 'apiInput', 'externalSensorId']),
  sensorId: z.string(),
  externalSensorId: z.string(),
  apiInput: z.boolean(),
  customName: z.string(),
  channelNumber: z.number().nullable().optional(),
});

export type UnitTypeInputFormValue = z.infer<typeof unitTypeInputValueSchema>;
